import type { FC} from 'react';
import { useLayoutEffect, useRef, useState } from 'react';

import { useProduct as useProducts } from '@src/entities/products';
import { useProduct } from '@src/library/hooks/shop';

import * as st from './styles.module.scss';

export const VideoPage: FC = () => {
	const id = useProduct().productId;
	const product = useProducts(id);

	const [videoHeight, setVideoHeight] = useState<number>(0);
	const elementRef = useRef<HTMLDivElement>(null);

	useLayoutEffect(() => {
		const calculateDynamicHeightAndWidth = () => {
			const ratioVideo = 1280 / 720;

			if (elementRef.current) {
				const windowHeight = window.innerHeight;
				const windowWidth = window.innerWidth > 1140 ? 1140 : window.innerWidth;

				setVideoHeight(
					windowWidth / ratioVideo > windowHeight - 104
						? windowHeight - 104
						: windowWidth / ratioVideo
				);
			}
		};
		calculateDynamicHeightAndWidth();

		window.addEventListener('load', calculateDynamicHeightAndWidth);
		window.addEventListener('resize', calculateDynamicHeightAndWidth);

		return () => {
			window.removeEventListener('load', calculateDynamicHeightAndWidth);
			window.removeEventListener('resize', calculateDynamicHeightAndWidth);
		};
	}, [location]);

	return (
		<>
			<div className={st.wrapper} ref={elementRef}>
				<div
					className={st.main}
					style={{
						width: `100%`,
						height: `100%`,
					}}
				>
					<iframe
						style={{
							width: `100%`,
							height: `${videoHeight}px`,
						}}
						className={st.frame}
						title="boomstream"
						src={`https://play.boomstream.com/${product?.product?.product_video.code}?title=0`}
						allowFullScreen
					/>
				</div>
			</div>
		</>
	);
};
